import * as React from "react";

import { Root } from "./Table2Row.styles";
import { Table2ColumnPaddingContext } from "./Table2ColumnPaddingContext";

export const Table2RowKindContext = React.createContext<"body" | "head">("body");

export function useTable2RowKind(): "body" | "head" {
    return React.useContext(Table2RowKindContext);
}

interface Table2RowProps {
    kind?: "head";
    children: React.ReactNode[];
    noBorder?: boolean;
    columnPadding?: string;
}

export function Table2Row(props: Table2RowProps): JSX.Element {
    const addPaddingContextIfNeed = (nodes: React.ReactNode[]) =>
        props.columnPadding ? (
            <Table2ColumnPaddingContext.Provider value={props.columnPadding}>
                {nodes}
            </Table2ColumnPaddingContext.Provider>
        ) : (
            nodes
        );

    return (
        <Root kind={props.kind} noBorder={props.noBorder}>
            <Table2RowKindContext.Provider value={props.kind ?? "body"}>
                {addPaddingContextIfNeed(props.children)}
            </Table2RowKindContext.Provider>
        </Root>
    );
}
